import React from "react"
import { Button, Col, Row } from "reactstrap"

function PastDueAppointmentTableHeader(props) {
  return (
    <Row className="align-items-center">
      <Col xs="8">
        <h3 className="mb-0">Histórico de Horas Vencidas</h3>
      </Col>
      <Col className="text-right" xs="4">
        <Button
          color="primary"
          onClick={props.openCreateAppointment}
          size="sm"
        >
          <i className="fas fa-plus mr-2" />
          Adicionar Apontamento
        </Button>
      </Col>
    </Row>
  )
}

export default PastDueAppointmentTableHeader